import { Box } from '@mui/material'
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import { tokens } from '../../theme'
import Header from '../../components/Header'
import { useTheme } from '@mui/material'
import React from "react"
import { useState, useEffect } from "react"
import { useNavigate } from 'react-router-dom'

import * as Constants from '../../constants'

import { ptBR as ptBRGrid } from '@mui/x-data-grid'

function arraysEqual(a1, a2) {
  return JSON.stringify(a1) === JSON.stringify(a2)
}

const Events = () => {
  const theme = useTheme()
  const colors = tokens(theme.palette.mode)
  const [rows, setRows] = useState([])

  let navigate = useNavigate()

  const handleRowClick = (e) => {
    console.log(e)
    navigate('/device/' + e.row.imei)
  }

  useEffect(() => {
    const fetchEvents = () => {
      fetch(Constants.HOST + '/events', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          token: JSON.parse(localStorage.getItem('user_data')).token,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          data = data.data
          let newRows = []
          data.events.forEach((event) => {
            var parsed = JSON.parse(event.json_data)
            var str = parsed
              ? parsed.manufacturer + ' ' + parsed.brand + ' ' + parsed.model
              : '?'
            newRows.push({
              id: event.id,
              description: event.description,
              imei: event.device_fk,
              device_data: str,
              timestamp: event.timestamp,
            })
          })
          if (!arraysEqual(rows, newRows)) setRows(newRows)
        })
        .catch((error) => {
          console.log(error)
        })
    }
    fetchEvents()
  }, [rows])

  const columns = [
    { field: 'id', headerName: 'ID', flex: 0.5 },
    { field: 'description', headerName: 'Descrição', flex: 1 },
    { field: 'imei', headerName: 'IMEI', flex: 1 },
    { field: 'device_data', headerName: 'Dados do Dispositivo', flex: 1 },
    { field: 'timestamp', headerName: 'Timestamp', flex: 1 },
  ]

  return (
    <Box m="20px">
      <Header title="Relatório de Eventos" />
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          '& .MuiDataGrid-root': {
            border: 'none',
          },
          '& .MuiDataGrid-cell': {
            borderBottom: 'none',
          },
          '& .name-column--cell': {
            color: colors.greenAccent[300],
          },
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: colors.blueAccent[700],
            borderBottom: 'none',
          },
          '& .MuiDataGrid-virtualScroller': {
            backgroundColor: colors.primary[400],
          },
          '& .MuiDataGrid-footerContainer': {
            borderTop: 'none',
            backgroundColor: colors.blueAccent[700],
          },
          '& .MuiCheckbox-root': {
            color: `${colors.greenAccent[200]} !important`,
          },
          '& .MuiDataGrid-toolbarContainer .MuiButton-text': {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          rows={rows ? rows : []}
          columns={columns}
          components={{ Toolbar: GridToolbar }}
          onRowClick={handleRowClick}
          localeText={ptBRGrid.components.MuiDataGrid.defaultProps.localeText}
        />
      </Box>
    </Box>
  )
}

export default Events
